<template>
  <v-card-text>
    <v-container>
      <v-col class="justify-center">
        <h1
          style="
            text-align: center;
            font-weight: 800;
            font-size: 28px;
            line-height: 36px;
            letter-spacing: 0.04em;
            font-family: Fira sans;
            font-style: normal;
          "
        >
          Sign In Now!
        </h1>
        <v-form ref="form" style="margin-top: 40px" lazy-validation>
          <v-text-field
            maxlength="50"
            id="username"
            flat
            outlined
            v-model.trim="email"
            placeholder="Email Address"
            required
            style="margin-bottom: 10px"
            :error-messages="
              $v.email.$errors.length ? $v.email.$errors[0].$message : ''
            "
            @keyup="onEnter"
          ></v-text-field>

          <v-text-field
            id="password"
            flat
            outlined
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            placeholder="Password"
            @click:append="show1 = !show1"
            style="margin-bottom: 10px"
            :error-messages="
              $v.password.$errors.length ? $v.password.$errors[0].$message : ''
            "
            @keypress="
              (ev) => {
                enter(ev);
              }
            "
          ></v-text-field>

          <!-- captcha -->
          <v-row v-if="isDevModeIPProtection && !bypasscaptcha.value" class="align-center" style="margin: 0;">
            <v-col cols="8" style="padding: 0 12px 0 0;">
              <img :src="captchaImage" alt="CAPTCHA" class="captcha-image" style="width: 100%; height: auto; border: 1px solid #e0e0e0; border-radius: 4px;" />
            </v-col>
            <v-col cols="4" class="d-flex align-center justify-start" style="padding: 0 0 0 8px; min-height: 50px;">
              <v-btn
                icon
                color="primary"
                title="Refresh CAPTCHA"
                @click="refetchCaptcha"
                class="captcha-refresh-btn"
                :disabled="refreshingCaptcha"
                :loading="refreshingCaptcha"
                style="min-width: 48px; height: 48px;"
                depressed
              >
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" style="padding: 12px 0 0 0;">
              <v-text-field
                v-model="captchaInput"
                flat
                outlined
                placeholder="Enter CAPTCHA"
                :error-messages="$v.captchaInput && $v.captchaInput.$errors && $v.captchaInput.$errors.length ? $v.captchaInput.$errors[0].$message : ''"
                style="margin-bottom: 10px"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="pt-2">
            <p
              @click="
                () => {
                  opendialogforgot = true;
                }
              "
              class="linkpointer text-right"
              style="font-weight: 600; font-size: 12px"
            >
              Forgot Password?
            </p>
          </div>

          <v-btn
            id="submit"
            block
            height="50"
            :disabled="loading"
            depressed
            color="secondary"
            class="mr-4 mt-7 text-capitalize font-weight-bold"
            @click="login"
          >
            {{ loading ? "Sign In..." : "Sign In" }}
          </v-btn>
          <br />
          <v-btn
            v-show="showBtnSignUp"
            to="/signup"
            exact
            block
            height="50"
            :disabled="loading"
            depressed
            outlined
            color="white"
            class="mr-4 mt-2 text-capitalize font-weight-bold"
            style="border: 1px solid #2c94d2"
          >
            <span class="secondary--text">Sign Up</span>
          </v-btn>
        </v-form>
      </v-col>
      <dialogfailloginVue
        :message="dialogfailloginMessage"
        :error_code="dialogfailloginErrorCode"
        v-model="dialogfaillogin"
        @reset="doReset"
        @close="
          () => {
            dialogfaillogin = false;
          }
        "
      />
      <DialogSystemUpgrade v-model="showSystemUpgradeDialog" />
    </v-container>
    <dialogForgot
      v-model="opendialogforgot"
      @success="
        () => {
          opendialogreset = true;
          dialogfaillogin = false;
        }
      "
      @error="
        (message) => {
          opendialogfailedforgot = true;
          dialogfailForgotMessage = message;
        }
      "
    />

    <dialogIP v-if="ipError" v-model="ipError" :errmsg="ipErrorMsg" />

    <dialogReset v-model="opendialogreset" />

    <dialogFailedReset
      v-model="opendialogfailedforgot"
      :message="dialogfailForgotMessage"
    />
  </v-card-text>
</template>
<script>
import { ref, onMounted } from "@vue/composition-api";
import { email, password, show1 } from "./emailpass";
import dialogfailloginVue from "./dialogfaillogin.vue";
import DialogSystemUpgrade from "./dialogsystemupgrade.vue";
import dialogFailedReset from "./dialogFailedReset.vue";
import dialogForgot from "./dialogForgot";
import dialogReset from "./dialogReset";
import { HOMEPAGE } from "./namespace";
import { useNamespacedActions, useNamespacedGetters } from "vuex-composition-helpers";
import useVuelidate from "@vuelidate/core";
import { required, email as Email, helpers } from "@vuelidate/validators";
import localstorage from "@/lib/localstorage";
import dialogIP from "./dialogIP";
import externalSubDomain from '@/lib/externalSubDomain'

// const isDevModeIPProtection = process.env.VUE_APP_DEV_MODE === 'fase-1.3'
const isDevModeIPProtection = true;

export default {
  components: {
    dialogfailloginVue,
    DialogSystemUpgrade,
    dialogForgot,
    dialogReset,
    dialogFailedReset,
    dialogIP,
  },
  setup(props, context) {
    // const $router = context.root.$router
    const dialogfailloginMessage = ref("");
    const dialogfailloginErrorCode = ref(400);
    const dialogfailForgotMessage = ref("");
    const opendialogforgot = ref(false);
    const opendialogfailedforgot = ref(false);
    const showSystemUpgradeDialog = ref(false);
    const showBtnSignUp = ref(true);

    const externalSubdomain = externalSubDomain.getSubDomain();
    onMounted(async () => {
      if (externalSubdomain !== "") {
        showBtnSignUp.value = false;
      }
      if (isDevModeIPProtection && !bypasscaptcha.value) {
        await fetchCaptcha();
      }
    });

    const $auth = context.root.$auth;

    const primary = context.root.$vuetify.theme.themes.light.primary;
    const loading = ref(false);
    const dialogfaillogin = ref(false);
    const { login: Login } = useNamespacedActions(HOMEPAGE, ["login"]);
    const { profile } = useNamespacedActions("CREATEORGANIZATION", ["profile"]);
    const { fetchCaptcha, verifyCaptcha } = useNamespacedActions(HOMEPAGE, ["fetchCaptcha", "verifyCaptcha"]);
    const { captchaImage } = useNamespacedGetters(HOMEPAGE, ["captchaImage"]);
    const email = ref();
    const password = ref();
    const captchaInput = ref("");
    const refreshingCaptcha = ref(false);

    const bypasscaptcha = ref(false);
    if (localStorage.getItem("captcha") && atob(localStorage.getItem("captcha")) == process.env.VUE_APP_BYPASS_CAPTCHA) {
      bypasscaptcha.value = true;
    }

    const refetchCaptcha = async () => {
      refreshingCaptcha.value = true;
      try {
        await fetchCaptcha();
        captchaInput.value = "";
      } catch (error) {
        console.error("Error refetching CAPTCHA:", error);
        context.root.$store.dispatch("HOMEPAGE/showErrorToast", "Failed to refresh CAPTCHA. Please try again.");
      } finally {
        refreshingCaptcha.value = false;
      }
    };

    const additionalRules = isDevModeIPProtection && !bypasscaptcha.value
      ? {
          captchaInput: { 
            required: helpers.withMessage("Captcha couldn't be empty.", (val) => {
              return bypasscaptcha.value ? true : !!val;
            }),
          },
        }
      : {};

    const additionalValidation = isDevModeIPProtection && !bypasscaptcha.value
      ? {
          captchaInput,
        }
      : {};

    const doReset = async () => {
      opendialogforgot.value = true;
    };

    const doFailedReset = async () => {
      opendialogfailedforgot.value = true;
    };

    const $v = useVuelidate(
      {
        email: { required, Email },
        password: { required },
        ...additionalRules,
      },
      { email, password, ...additionalValidation }
    );

    const ipError = ref(false);
    const ipErrorMsg = ref("");

    async function login() {
      $v.value.$touch();
      if ($v.value.$errors.length) {
        return;
      }
      loading.value = true;

      try {
        let verify;
        if (isDevModeIPProtection && !bypasscaptcha.value) {
          verify = await verifyCaptcha({
            captcha: captchaInput.value,
          });

          if (verify?.data?.status == "failed") {
            captchaInput.value = "";
            loading.value = false;
            dialogfailloginMessage.value = "Invalid CAPTCHA. Please try again.";
            dialogfailloginErrorCode.value = 400;
            dialogfaillogin.value = true;
            refetchCaptcha();
            return;
          }
        }

        const data = await Login({
          email: email.value,
          password: password.value,
          captcha: bypasscaptcha.value ? localStorage.getItem("captcha") : captchaInput.value,
        });

          const needForceChangePassword = data.enforce_password || (password.value && password.value.length < 16);

          if (data.need_validate) {
            localstorage.setItem("need_validate", true);
            if (data.is_mfa_active) {
              return this.$router.push('/otp')
            }
            // return this.$router.push('/otp')
            ipError.value = true;

            const errmsg = [
              "IP address",
              "device",
              "IP address and the device",
            ];

            ipErrorMsg.value = errmsg[data.validate_reason - 1];
          } else if (needForceChangePassword) {
            localstorage.setItem("force_change_password", true);
            return window.location.href = "/force-change-password";
          } else if (data.need_create_organization) {
            localstorage.setItem("need_create_organization", true);
            return this.$router.push("/create-organization");
          } else if (data.need_create_project && data.role !== "Superadmin") {
            localstorage.setItem("need_create_project", true);
            profile().then((res) => {
              const orgid = res.data.organization_id;
              localstorage.setItem("orgid", orgid);
              return this.$router.push("/create-new-project");
            });
          } else {
            if (data.role == "Superadmin") {
              localstorage.removeItem("need_create_organization");
              localstorage.removeItem("need_create_project");
              context.root.$VueEvent.emit("after-check-login", data);

              // return this.$router.push("/manage-organization");
              return window.location.href="/manage-organization";
            } else if (data.role == "GodMode") {
              localstorage.removeItem("need_create_organization");
              localstorage.removeItem("need_create_project");
              context.root.$VueEvent.emit("after-check-login", data);

              // return this.$router.push("/manage-superadmin");
              return window.location.href="/manage-superadmin";
            } else {
              localstorage.removeItem("need_create_organization");
              localstorage.removeItem("need_create_project");
              context.root.$VueEvent.emit("after-check-login", data);

              return window.location.href="/project";

            }
          }
      } catch (e) {
        if (e.message == "Network Error") {
          loading.value = false;
          return;
        }
        // Show system upgrade dialog for AUTH-004
        if (e.code === "AUTH-004") {
          showSystemUpgradeDialog.value = true;
        } else {
        dialogfailloginMessage.value = e.data;
        dialogfailloginErrorCode.value = e.code;
        dialogfaillogin.value = true;
        }
        if (isDevModeIPProtection && !bypasscaptcha.value) {
          refetchCaptcha();
        }
      } finally {
        loading.value = false;
      }
    }
    return {
      ipErrorMsg,
      ipError,
      enter(e) {
        if (e.code == "Enter") {
          login();
        }
      },
      $v,
      doReset,
      doFailedReset,
      dialogfailloginErrorCode,
      dialogfailForgotMessage,
      dialogfailloginMessage,
      opendialogfailedforgot,
      opendialogforgot,
      opendialogreset: ref(false),
      email,
      password,
      show1,
      showSystemUpgradeDialog,
      primary,
      login,
      loading,
      dialogfaillogin,
      showBtnSignUp,
      captchaImage,
      captchaInput,
      refetchCaptcha,
      bypasscaptcha,
      refreshingCaptcha,
    };
  },
  data() {
    return {
      isDevModeIPProtection,
    };
  },
  watch: {
    dialogfaillogin(newVal) {
      if (newVal) {
        const bypasscaptcha = localStorage.getItem("captcha") && atob(localStorage.getItem("captcha")) == process.env.VUE_APP_BYPASS_CAPTCHA;
        if (isDevModeIPProtection && !bypasscaptcha && this.refetchCaptcha) {
          this.refetchCaptcha();
        }
      }
    },
  },
  methods: {
    onEnter(e) {
      this.email = this.email.toLowerCase();
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card__text {
  ::v-deep .v-btn__content {
    font-family: Fira sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.02em;
  }
}

.captcha-image {
  width: 100%;
  height: auto;
}

.captcha-refresh-btn {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.captcha-refresh-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}
</style>
